<template lang="pug">
  div
    div.wishlist-button(v-if="isLoading")
      font-awesome-icon(:icon=['far', 'circle-notch'] spin)
    div.wishlist-button(
      @click.prevent="onAdd"
      v-if="this.$store.getters['wishlist/items'].indexOf(this.itemCode) < 0 && !isLoading"
    )
      font-awesome-icon(:icon=['far', 'heart'])
    div.wishlist-button.wishlist-button--added(
      @click.prevent="onRemove"
      v-if="this.$store.getters['wishlist/items'].indexOf(this.itemCode) >= 0  && !isLoading"
    )
      font-awesome-icon(:icon=['fas', 'heart'])
</template>

<script>
import router from '../../../routes';
import notify from '../../notify';

export default {
  props: {
    itemCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    isAdded() {
      const index = _.indexOf(this.$store.getters['wishlist/items'], this.itemCode);
      console.log(index);
      if (index >= 0) {
        return true;
      }
      return false;
    },
    async onAdd() {
      if (!this.$store.getters['auth/isLoggedIn']) {
        notify.message(this, { title: Lang.get('alerts.frontend.general.not_login'), text: false }, 'danger');
        router.push('/login');
        return;
      }
      this.isLoading = true;
      try {
        await this.$store.dispatch('wishlist/add', { item_code: this.itemCode });
        notify.success(this, { title: Lang.get('alerts.frontend.general.added_to_wishlist') });
      } catch (err) {
        console.log(err);
        notify.clean(this).then(() => notify.errors(this, err));
      }
      this.isLoading = false;
    },
    async onRemove() {
      if (!this.$store.getters['auth/isLoggedIn']) {
        notify.message(this, { title: Lang.get('alerts.frontend.general.not_login'), text: false }, 'danger');
        return;
      }
      this.isLoading = true;
      try {
        await this.$store.dispatch('wishlist/remove', { item_code: this.itemCode });
        notify.success(this, { title: Lang.get('alerts.frontend.general.deleted_from_wishlist') });
      } catch (err) {
        console.log(err);
        notify.clean(this).then(() => notify.errors(this, err));
      }
      this.isLoading = false;
    },
  },
};
</script>
